var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-dv-box',{attrs:{"layout":"","gap":40,"width":"calc(100% - 40px)","height":"100%","x-align":"center"}},[_c('my-dv-box',{attrs:{"fit":"","gap":40,"width":"100%"}},[_c('Graph')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }